import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { ModernButton } from "./DefaultImports";
import { modalActionStyles } from "./modalActionStyles";

// 🔧 Garante que o backdrop da confirmação fique acima de outros modais
const ConfirmationModalStyles = createGlobalStyle`
  .modal-backdrop.confirmation-backdrop {
    z-index: 1055 !important;
  }
`;

const StyledModal = styled(Modal)`
  z-index: 99999 !important;

  .modal-dialog {
    max-width: 420px;
    width: calc(100% - 20px);
    margin: ${({ $topSpacing }) => $topSpacing || "20px auto"};
  }

  .modal-content {
    border-radius: 16px;
    border: 1px solid rgba(229, 224, 215, 0.8);
    box-shadow: 0 24px 70px rgba(75, 51, 53, 0.16);
    overflow: hidden;
  }

  .modal-header {
    position: relative;
    background-color: #ffffff;
    border: none;
    border-bottom: 1px solid #ece6de;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 58px;
    padding: 1rem 1.25rem;
  }

  .modal-title {
    margin: 0;
    padding-right: 42px;
    font-weight: 700;
    font-size: 17px;
    color: var(--app-orange, #ee754c);
    letter-spacing: -0.015em;
  }

  .modal-body {
    padding: 1.25rem;
    font-size: 15px;
    color: #333;
  }

  .modal-footer {
    background-color: white;
    border: none;
    border-top: 1px solid #f1ece7;
    padding: 1rem 1.25rem;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }

  ${modalActionStyles}
`;

const CloseButton = styled.button`
  position: absolute;
  top: 14px;
  right: 16px;
  width: 30px;
  height: 30px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: #f5f2ef;
  color: #756a6c;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.16s ease;

  &:hover {
    background: #fff0e9;
    color: #d9603b;
  }

  svg {
    font-size: 14px;
  }
`;

export const ConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  title = false,
  body = false,
  confirmLabel = false,
  cancelLabel = false,
  confirmColor = false,
  cancelColor = false,
  onCancel = null,
  topSpacing = null,
  centered = !topSpacing,
  blockCloseButton = false,
  confirmDisabled = false,
}) => {
  if (!show) return null;

  return (
    <>
      <ConfirmationModalStyles />
      <StyledModal
        show={show}
        onHide={onHide}
        centered={centered}
        backdrop="static"
        keyboard={false}
        $topSpacing={topSpacing}
        backdropClassName="confirmation-backdrop"
      >
        <div className="modal-header">
          {title && <h5 className="modal-title">{title}</h5>}
          {blockCloseButton ? (
            <></>
          ) : (
            <CloseButton type="button" onClick={onHide} aria-label="Close">
              <FontAwesomeIcon icon={faXmark} />
            </CloseButton>
          )}
        </div>

        {body && <div className="modal-body">{body}</div>}

        <div className="modal-footer">
          {cancelLabel && (
            <ModernButton
              color={cancelColor}
              fontSize="14px"
              onClick={onCancel || onHide}
            >
              {cancelLabel}
            </ModernButton>
          )}
          {confirmLabel && (
            <ModernButton
              color={confirmColor}
              fontSize="14px"
              onClick={onConfirm}
              disabled={confirmDisabled}
            >
              {confirmLabel}
            </ModernButton>
          )}
        </div>
      </StyledModal>
    </>
  );
};
